import { render, staticRenderFns } from "./DailyHealthV4.vue?vue&type=template&id=58518105&scoped=true&"
import script from "./DailyHealthV4.vue?vue&type=script&lang=js&"
export * from "./DailyHealthV4.vue?vue&type=script&lang=js&"
import style0 from "./DailyHealthV4.scss?vue&type=style&index=0&id=58518105&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58518105",
  null
  
)

export default component.exports